import React, { useEffect, useState } from 'react';

import Logo2 from '../../assets/navbar/logo.svg';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router';
// api 
import { ApiHelper } from '../../utilFunctions/utilfunction';

const VerifyEmail = () => {

    const [banner, setBanner] = useState();
    const [message, setMessage] = useState('');
    const { id, token } = useParams(); // ✅ Get params


    useEffect(() => {
        const fetchData = async () => {
          try {
            const bannerdata = await ApiHelper("/banner");
            setBanner(bannerdata);
    
            if (id && token) {
              const verifyRes = await ApiHelper(
                "/verify-email",
                {
                  user_id: id,
                  token: token,
                },
                "POST"
              );
      
              if (verifyRes?.status === true && verifyRes?.code === 200) {
                setMessage( verifyRes?.message || "Email verified successfully!!\nPlease login to continue.");
              } else {
                setMessage("Email verification failed or link is invalid.");
              }
            }
          } catch (err) {
            console.error("Error verifying email:", err);
            setMessage("Email verification failed or link is invalid.");
          }
        };
      
        fetchData();
      }, [id, token]);
      
    const navigate = useNavigate();

    return (
        <section className='mainhomepage '>

            <div className='wholepopup d-flex justify-content-center align-items-center w-100'>

                <div className='container d-flex flex-column back_image_color flex-md-row align-items-center ps-lg-0 pe-lg-0 mb-5'>
                    {
                        banner && banner.data.length ?
                            <div className='col-12 col-md-6'>
                                {
                                    banner.data.map((value, index) =>

                                        <img key={index} className='for_height mw-100 w-100' src={value ? value.image_path : ""} alt="image" />

                                    )
                                }
                            </div>

                            :
                            <div className='col-12 col-md-6'>
                            </div>
                    }

                    <div className='col-12 col-md-6'>

                        <div className='rightside_content d-flex justify-content-center align-items-center position-relative' style={{ background: '#f0f0f0' }}>

                            <div className='d-flex flex-column align-items-center'>

                                <img className='logo2_bottom mt-4' src={Logo2} alt="logo" />




                                <hr className="my-2" style={{ width: '90%' }} />
                                {
                                    message && (
                                        <div className="social-text_content2 d-flex flex-column align-items-center text-center mt-3">
                                            <h4 style={{ marginBottom: '30px', fontWeight: 'semibold', paddingInline: '10px' }}>
                                                {message}
                                            </h4>
                                            <button
                                                className="auth-button"
                                                style={{
                                                    width: '300px',
                                                    fontFamily: 'Times New Roman',
                                                    fontWeight: 'bold',
                                                    marginTop: '15px'

                                                }}
                                                onClick={() => navigate('/login')}
                                            >
                                                Login
                                            </button>

                                        </div>
                                    )
                                }

                            </div>

                        </div>

                    </div>

                </div>
            </div>

        </section >
    );
};

export default VerifyEmail;
